module.exports = __webpack_public_path__ + "static/media/landing-health-management-phone.5ec05ca8.png";